module.exports = identity
function identity(d) {
  return d
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/rehype-highlight/node_modules/unist-util-visit-parents/color.browser.js
// module id = MEVl
// module chunks = 0